import { NavLink, useNavigate, Navigate } from 'react-router-dom'
import { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';

// Import TinyMCE core and required plugins/themes
import 'tinymce';
// import 'tinymce/themes/silver';
// import 'tinymce/icons/default';
// import 'tinymce/plugins/advlist';
// import 'tinymce/plugins/autolink';
// import 'tinymce/plugins/lists';
// import 'tinymce/plugins/link';
// Add other plugins as needed


export default function MessageEditor () {

    const editorRef = useRef(null);

    const log = () => {
        if (editorRef.current) {
            console.log(editorRef.current.getContent());
        }
    };

  return (

    <>

    <Editor
        tinymceScriptSrc = '/tinymce/tinymce.min.js'

        apiKey='no-api-key'

        onInit={(evt, editor) => editorRef.current = editor}

        initialValue="<p>This is the initial content of the editor.</p>"

        init={{
            height: 500,
            plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount'
            ],
            toolbar: 'undo redo | formatselect | bold italic underline | \
                alignleft aligncenter alignright alignjustify | \
                bullist numlist outdent indent | link image | removeformat | help',

            menubar: 'file edit view insert format tools table help',

            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
            
            skin_url: '/tinymce/skins/ui/oxide',
            icons_url: '/tinymce/icons/default/icons.min.js',
            branding: false
        }}
    />

    <button onClick={log}>Log editor content</button>

    </>

  );

}